module.exports = __webpack_public_path__ + "h5/img/index1-0.94e594df.png";